import styleInject from 'style-inject';

var css_248z = ".alert-module_error__OhUYl {\n}\n\n.alert-module_message__Bw6wS {\n}\n\n.alert-module_warning__SckBU {\n}\n\n.alert-module_success__US636 {\n}\n\n.alert-module_loading__h8ZYU {\n}\n";
var styles = {"error":"alert-module_error__OhUYl","message":"alert-module_message__Bw6wS","warning":"alert-module_warning__SckBU","success":"alert-module_success__US636","loading":"alert-module_loading__h8ZYU"};
styleInject(css_248z,{"insertAt":"top"});

export { styles as default };
